import { render } from "./InstantLinkBtcDetails.vue?vue&type=template&id=62360dc8&scoped=true"
import script from "./InstantLinkBtcDetails.vue?vue&type=script&lang=js"
export * from "./InstantLinkBtcDetails.vue?vue&type=script&lang=js"

import "./InstantLinkBtcDetails.vue?vue&type=style&index=0&id=62360dc8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62360dc8"]])

export default __exports__